import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { serverStatusService } from '../services/serverStatusService';

interface ServerStatusContextType {
  isServerReachable: boolean;
  setServerReachable: (reachable: boolean) => void;
  showErrorIndicator: boolean;
  setShowErrorIndicator: (show: boolean) => void;
}

const ServerStatusContext = createContext<ServerStatusContextType | undefined>(undefined);

export const ServerStatusProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isServerReachable, setIsServerReachable] = useState(true);
  const [showErrorIndicator, setShowErrorIndicator] = useState(false);

  const setServerReachable = (reachable: boolean) => {
    setIsServerReachable(reachable);
    if (!reachable) {
      setShowErrorIndicator(true);
      setTimeout(() => setShowErrorIndicator(false), 5000);
    } else {
      setShowErrorIndicator(false);
    }
  };

  useEffect(() => {
    serverStatusService.setCallback(setServerReachable);
  }, []);

  return (
    <ServerStatusContext.Provider value={{
      isServerReachable,
      setServerReachable,
      showErrorIndicator,
      setShowErrorIndicator
    }}>
      {children}
    </ServerStatusContext.Provider>
  );
};

export const useServerStatus = () => {
  const context = useContext(ServerStatusContext);
  if (context === undefined) {
    throw new Error('useServerStatus must be used within a ServerStatusProvider');
  }
  return context;
};